function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

class AcceptMarketing extends HTMLElement {
    constructor() {
        super();

        this.parentForm = this.closest('form');
        this.submitBtn = this.parentForm.querySelector('button[type="submit"]');


        this.newsletterForm = document.querySelector('#ContactFooter');

        this.eventListeners();
    }
    connectedCallback() {
        this.checkbox = this.querySelector('#accept-marketing');
        this.marketingHTML(this.checkbox.checked);
        this.checkbox.addEventListener('click', this.handleAcceptMarketing.bind(this));

        // window.Shopify.captcha.protect(this.parentForm);
    }

    handleAcceptMarketing(e) {
        const isChecked = e.target.checked;

        this.marketingHTML(isChecked);
    }
    marketingHTML(isChecked) {
        if (isChecked) {
            this.parentForm.setAttribute('data-require-newsletter', 'true');
        } else {
            this.parentForm.removeAttribute('data-require-newsletter');
        }


    }
    setErrorMessage(error, resetCaptcha) {
        const errorMessageWrapper = this.parentForm.querySelector('[data-error-message-wrapper]');
        const errorMessage = this.parentForm.querySelector('[data-error-message]');

        errorMessage.textContent = error;
        errorMessageWrapper.classList.remove('d-none');
        errorMessageWrapper.focus();

        if (resetCaptcha) grecaptcha.reset();

    }
    eventListeners() {
        this.parentForm.addEventListener('submit', (e) => {
            e.preventDefault();

            const captchaResponse = grecaptcha.getResponse();
            if (!captchaResponse.length > 0) {
                this.setErrorMessage('Please tick the I\'m not a robot check box.', false);

                return;
            }

            const body = Array.from(this.parentForm.querySelectorAll('[name^="contact"]')).map((input) => {
                const rawName = input.name.replace(/^contact\[/, '').replace(/\]$/, '');
                const label = capitalize(rawName);

                if (input.value === '') return;
                if (input.type === 'checkbox' && input.checked === false) return;

                return `<div><p><b>${label}</b>: ${input.value}</p></div>`;
            }).join('');

            const fname = this.parentForm.querySelector('[name="contact[first name]"]') || this.parentForm.querySelector('[name="contact[your first name]"]');
            const lname = this.parentForm.querySelector('[name="contact[surname]"]') || this.parentForm.querySelector('[name="contact[your surname]"]') || this.parentForm.querySelector('[name="contact[last name]"]');

            const submitButton = this.parentForm.querySelector('[type="submit"]')

            submitButton.setAttribute('disabled', 'disabled');
            const originalButtonText = submitButton.innerHTML;
            submitButton.innerHTML = 'Submitting...';
           
            const raw = JSON.stringify({
                "g-recaptcha-response": captchaResponse,
                "email": this.dataset.emailTo,
                "emailFrom": this.parentForm.querySelector('[name="contact[email]"]').value,
                "fname": fname.value,
                "lname": lname.value,
                "subject": this.dataset.emailSubject,
                "body": body,
                "isNewsletter": this.checkbox.checked,
            });

            fetch(this.parentForm.action,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: raw,
                    redirect: 'follow',
                })
                .then(async response => {                    
                    if (!response.ok) {
                        const errorText = await response.text();
                        submitButton.innerHTML = originalButtonText;
                        throw new Error(errorText);
                    }
                    return response.text();
                } )
                .then((result) => {
                    console.log(result);
                    
                    this.parentForm.querySelector('[data-sucess-message]').classList.remove('d-none');
                    this.parentForm.querySelector('#ContactFooter-success').focus()

                    if (this.dataset.redirectUrl) {
                        window.location.href = this.dataset.redirectUrl;
                    }

                    this.parentForm.reset();
                })
                .catch((error) => {
                    console.log(error.message);
                    this.setErrorMessage(error.message, true);
                    submitButton.innerHTML = originalButtonText;
                });
        });
    }
}

customElements.define('accept-marketing', AcceptMarketing);